export const ArrowRight24 = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none'>
		<path
			d='M12.7373 7.95361C13.0395 7.67032 13.5136 7.68561 13.7969 7.98779L17.5469 11.9878L17.6357 12.103C17.8128 12.3861 17.7833 12.761 17.5469 13.0132L13.7969 17.0132C13.5137 17.3152 13.0395 17.3303 12.7373 17.0474C12.4351 16.7641 12.4199 16.29 12.7031 15.9878L15.2695 13.2505H7C6.58593 13.2505 6.25024 12.9145 6.25 12.5005C6.25 12.0863 6.58579 11.7505 7 11.7505H15.2695L12.7031 9.01318C12.4198 8.71102 12.4352 8.23692 12.7373 7.95361Z'
			fill='currentColor'
		/>
	</svg>
);
